<template>
  <!--头部开始-->
  <div style="height: 60px;">
    <el-header class="header" :style="hotelLogoFixed">
      <!--中部开始-->
      <!-- pc版本 -->
      <el-row class="header-middle header-pc">
        <!--左侧导航 开始-->
        <el-col :span="12" class="grid-content bg-purple left-menu-logo" style="display: none">
<!--        <img class="menu-logo-img" :src="menuLogo" @click="setCollapse">-->
        </el-col>
        <!--左侧导航 结束-->
        <!--左侧logo 开始-->
        <div style="width: 100%;">
          <el-col :span="12" class="grid-content bg-purple left-logo">
            <img class="img" src="/static/img/logo-long.png" style="cursor:pointer;" @click="gotoHome">
          </el-col>
          <!--左侧logo 结束-->
          <!--切换公司 开始-->
          <!-- <div style="width:400px; float: left; margin-top: 10px;">
            <el-select style="width:250px;" v-model="selectSource" filterable @change="changeSource">
              <el-option v-for="(item, key) in sourceList" :key="key" :label="key" :value="key" class="option-item">
                {{key}}<span style="float: right; font-size: 12px;">{{item}}</span>
              </el-option>
            </el-select>
          </div> -->
          <!--切换公司 结束-->
          <!--右侧logo 开始-->
          <div style="width: auto;float: right;">
            <!--积分展示-->
            <el-col class="header-pointInfo">
              <div>
                <el-popover placement="bottom" trigger="hover" class="point-popover">
                  <div class="point-detail">
                    <div class="point-title">
                      <div class="point-loyalty">{{$t('loyaltyPoints')}}</div>
                      <div class="point-loyalty-li">Current Available Points (Historically Accumulated): {{(points.currentPoints ? Number(points.currentPoints) : 0).toLocaleString()}} , Pending Points (Awaiting Return): {{(points.pendingPoints ? Number(points.pendingPoints) : 0).toLocaleString()}}</div>
                    </div>
                    <div class="quarter-row-title">
                      <div class="quarter-col">{{$t('quarter')}}</div>
                      <div class="quarter-col">{{$t('quantity')}}</div>
                      <div class="quarter-col">{{$t('sales')}}</div>
                      <div class="quarter-col">{{$t('loyalty')}}</div>
                      <div class="quarter-col">{{$t('currentPoints')}}</div>
                      <div class="quarter-col">{{$t('pendingPoints')}}</div>
                    </div>
                    <div v-for="(item, index) in points.quarterSummary" :key="index">
                      <div class="quarter-row">
                        <div class="quarter-col">{{item.Quarter}}</div>
                        <div class="quarter-col">{{item.OrderQuantity}}</div>
                        <div class="quarter-col">{{item.Sales}}</div>
                        <div class="quarter-col">{{item.LoyaltyLevel || '-'}}</div>
                        <div class="quarter-col">{{item.PointsUsed || '-'}}</div>
                        <div class="quarter-col">{{item.PendingPoints || '-'}}</div>
                      </div>
                    </div>
                    <div class="points-progress">
                      <span style="color: #5566A1;font-weight: 600;">{{$t('progressBar')}}: </span>
                      <span style="color: #4E5969;">Only {{points.upgradeCurrency}} {{points.upgradeAmount}} Sales away from {{points.nextLevel}}! Keep going!</span>
                    </div>
                    <div style="display: flex; gap: 20px;">
                      <el-button type="text" style="font-weight: 400;font-size: 16px;text-decoration: underline;" @click="showPointsDialog">{{$t('pointsRules')}}</el-button>
                      <el-button type="text" style="font-weight: 400;font-size: 16px;text-decoration: underline;" @click="showPointsDetailsDialog">{{$t('pointsDetails')}}</el-button>
                    </div>
                  </div>
                  <div slot="reference" style="display: flex; align-items: center;">
                    <span style="font-weight: 500;color: #5566A1;">{{$t('pointStr')}}: </span>
                    <span style="font-weight: 400;color: #2F7000;">{{(points.currentPoints ? Number(points.currentPoints) : 0).toLocaleString()}} </span>
                    <span style="font-weight: 400;color: #2F7000;">({{$t('pendingPoints')}}: {{(points.pendingPoints ? Number(points.pendingPoints) : 0).toLocaleString()}})</span>
                    <img src="/static/img/question/circle-fill.png" style="width: 20px; height: 20px;cursor: pointer;" @click="showPointsDetailsDialog">
                  </div>
                </el-popover>
              </div>
            </el-col>
            <el-col :span="12" class="header-login">
              <div class="grid-content bg-purple right-header">
                <el-menu :default-active="defaultActive" class="el-menu-demo" menu-trigger="click" :unique-opened="true" mode="horizontal" @select="handleSelect" ref="headMenu">
                  <el-submenu index="2" v-show="showCurrency">
                    <template slot="title">
                      <span class="username font-gray" style="color:rgb(83, 102, 163);overflow: hidden;text-overflow: ellipsis;white-space: nowrap;float: left;">{{defaultCurrency}}</span>
                      <el-avatar src="/static/img/currency.png" style="margin: 17.5px 0 17.5px 2px; float: left;"></el-avatar>
                    </template>
                    <div class="userItem">
                      <div v-for="(item, key) in allCurrency" :key="key">
                        <el-menu-item @click="currencySwitch(key)" popper-class="currencyClass" class="account-menu">
                          <div style="width: 46px; float: left; height: 36px; "><img style="width: 36px; margin-top: -5px;" :src="'/static/img/' + key + '.png'"></div>
                          <div style="width: 88px;float: left; text-align: left;color:rgb(83, 102, 163);" v-if="key === defaultCurrency"><span style="float: left; width: 65%;">{{key}}</span><span style="float: right;width: 35%;">{{item}}</span></div>
                          <div style="width: 88px;float: left;" v-else><span style="float: left;width: 65%;">{{key}}</span><span style="float: right;width: 35%;">{{item}}</span></div>
                          <div style="width: 46px;float: right; height: 36px; text-align: center; " v-if="key === defaultCurrency"><i class="el-icon-check" style="color:rgb(83, 102, 163)"></i></div>
                        </el-menu-item>
                      </div>
                    </div>
                  </el-submenu>
                  <el-submenu index="1" v-show="userLogin" popper-class="userClass" style="line-height: 60px;">
                    <template slot="title">
                      <el-avatar src="/static/img/u3.png" style="margin: 17.5px 0 17.5px 2px; float: left;"></el-avatar>
                      <span class="username font-gray" style=" height:60px;color:rgb(83, 102, 163);overflow: hidden;text-overflow: ellipsis;white-space: nowrap;float: left;">{{LoginFirstName}}</span>
                      <span class="user-tag">{{userTag()}}</span>
                    </template>
                    <div class="userItem">
                      <div style="padding:0 10px;">
                        <div style="height: 40px;">
                          <span style="width: 40px; height: 40px; float: left;"><img src="/static/img/u104.png" style="width: 36px; height: 36px; margin: 2px 0;"></span>
                          <span style="float: left; margin-left: 5px;" :class="{'lineheight': email === ''}">
                            <span style="font-size: 16px; font-weight: 500;color:rgb(83, 102, 163); display: block;margin-bottom: 2px;">{{username}}</span>
                            <span style="font-size: 12px; color:#333333; display: block;" v-if="email !== ''">{{email}}</span>
                          </span>
                        </div>
                        <div style="margin: 15px 0;color:#333; font-size: 12px;color:#296FF7;">{{companyName}}</div>
                      </div>
                      <!-- <el-menu-item v-if="permissions.account === 1" @click="accountClick" class="account-menu">{{$t('myAccount')}}</el-menu-item> -->
                      <el-menu-item @click="loginOut" class="account-menu">{{$t('signOut')}}</el-menu-item>
                    </div>
                  </el-submenu>
                </el-menu>
              </div>
            </el-col>
            <!-- 余额展示 -->
            <el-col :span="12" class="balance-info" v-show="(permissions.showBalance === 1 || permissions.showBalance === '1') && limitInfo.amount !== '0'">
              <div>Credit Balance: <span style="color: #FF3B30;">{{limitInfo.currency}} {{limitInfo.amount}}</span></div>
            </el-col>
          </div>
          <!--右侧logo 结束-->
        </div>
      </el-row>
      <frameTermAndUse :frameTermAndUseDialog="frameTermAndUseDialog"></frameTermAndUse>
      <framePoints :framePointsDialog.sync="framePointsDialog"></framePoints>
      <framePointsDetails ref="pointsDetails" :framePointsDetailsDialog.sync="framePointsDetailsDialog"></framePointsDetails>
    </el-header>
  </div>
  <!--头部结束-->
</template>

<script>
import { getUserInfo } from '@/request/user.js'
import { signIn, changeSource } from '@/request/login.js'
import frameTermAndUse from '@/components/public/frameTermAndUse'
import framePoints from '@/components/public/framePoints'
import framePointsDetails from '@/components/public/framePointsDetails'
export default {
  name: 'publicHeader',
  props: {
    hotelLogoFixed: {
      default: false
    },
    curPageData: {
      default: ''
    },
    accountChange: ''
  },
  components: {
    frameTermAndUse,
    framePoints,
    framePointsDetails
  },
  data () {
    return {
      defaultActive: '',
      defaultCurrency: '',
      HomeRightMenu: false,
      userLogin: false,
      showCurrency: true,
      showLogin: ['WritePay', 'PayCallbackResult', 'tripDetail'].includes(this.curPageData) === false,
      webLanguage: this.common.webLanguage,
      LoginFirstName: '',
      languageShow: true,
      isCollapse: this.common.collapseSet(),
      menuLogo: '/static/img/u6.svg',
      source: this.common.sourceSet(),
      sourceList: '',
      selectSource: this.common.sourceSet(),
      allCurrency: ['USD', 'CNY'],
      limitInfo: [],
      search_json: {},
      permissions: {'cancel_scene': '2', 'order': 0, 'pay': 0, 'search': 0, 'showBalance': 0},
      activeIndex2: '1',
      isAccountActive: false,
      normalAccountImage: '/static/img/u3.png',
      activeAccountImage: '/static/img/u114',
      email: '',
      username: '',
      companyName: '',
      frameTermAndUseDialog: false,
      framePointsDialog: false,
      framePointsDetailsDialog: false,
      points: []
    }
  },
  watch: {
    accountChange: function () {
      this.getHeadUserInfo()
    }
  },
  beforeMount () {
    this.getHeadUserInfo()
  },
  created () {
    // var firstLogin = localStorage.getItem('firstLogin')
    // if (firstLogin === true || firstLogin === 'true') {
    //   //this.framePointsDialog = true
    //   // this.frameTermAndUseDialog = true
    // } else {
    //   //this.framePointsDialog = false
    //   // this.frameTermAndUseDialog = false
    // }
    // 币种
    var urlCur = localStorage.getItem('currencySet')
    if (window.performance.navigation.type !== 1 && this.$route.query.currency !== undefined && this.$route.query.currency !== '') {
      urlCur = this.$route.query.currency
    }
    if (urlCur === null || urlCur === 'undefined') {
      this.currencySwitch(this.defaultCurrency)
    } else {
      this.currencySwitch(urlCur)
    }
    // 保存当前页面的 regionSel
    // var regionSelJson = sessionStorage.getItem('regionSel')
    // var regionSelDetail = JSON.parse(regionSelJson)
    // // if (regionSelDetail !== 'null' && regionSelDetail !== null && regionSelDetail.value_zh != null && regionSelDetail.value_en != null) {
    //   var regionSel = {'value_zh': regionSelDetail.value_zh, 'value_en': regionSelDetail.value_en, 'type_id': regionSelDetail.type_id, 'type_data_id': regionSelDetail.type_data_id}
    // }
    var token = localStorage.getItem('token')
    if ((token === undefined || token === null || token === 'null') && this.$route.path.indexOf('forgetPass') === -1) {
      let locationHref = window.document.location.href
      localStorage.setItem('LoginWebsiteAddress', locationHref)
      this.$router.push({name: 'login'})
    }
    // 监听点击事件
    let that = this
    document.addEventListener('click', function (e) {
      if (that.$refs.headMenu !== undefined && !that.$refs.headMenu.$el.contains(e.target)) {
        // 在区域外点击时，收起菜单
        that.$refs.headMenu.close('1')
        that.$refs.headMenu.close('2')
      }
    })
  },
  mounted () {
    // 存储来源
    this.source = this.common.sourceSet()
    var source = this.common.sourceSet()
    // 过期时间 5个小时
    if (source !== '' && source !== undefined && source !== null) {
      this.source = source
      var sourceExpiresAt = Date.now() + 3600000 * 5
      localStorage.setItem('source', this.source)
      localStorage.setItem('sourceExpiresAt', sourceExpiresAt)
    } else {
      source = this.$route.query.source
      var sourceExpires = localStorage.getItem('sourceExpiresAt')
      if (sourceExpires !== '' && sourceExpires !== undefined && sourceExpires !== null) {
        var nowTime = Date.now()
        if (nowTime > sourceExpires) {
          localStorage.removeItem('source')
          localStorage.removeItem('sourceExpiresAt')
        } else {
          // 避免手动干预删除或者修改localStorage
          if (source === '' || source === undefined || source === null) {
            localStorage.removeItem('source')
            localStorage.removeItem('sourceExpiresAt')
          } else {
            this.source = source
            this.common.sourceSet(source)
          }
        }
      }
    }
    if (this.source === '' || this.source === undefined || this.source === null) {
      let locationHref = window.document.location.href
      localStorage.setItem('LoginWebsiteAddress', locationHref)
      this.$router.push({name: 'login'})
    }
    this.selectSource = this.source
    var path = this.$route.path
    if (this.$route.path === '/' || this.$route.path === '/portal/account/MyTrip') {
      var query = JSON.parse(JSON.stringify(this.$route.query))
      query.source = this.source
      this.$router.push({path: '/portal/account/MyTrip', query: query})
    }
    if (path.indexOf('HotelList') !== -1 || path.indexOf('HotelDetail') !== -1) {
      this.showCurrency = true
    } else {
      this.showCurrency = false
    }
    // if (path.indexOf('WritePay') === -1 || path.indexOf('WriteOrder') === -1) {
    // }
  },
  filters: {
    capitalize: function (value) {
      if (!value) return ''
      value = value.toString()
      return value.charAt(0).toUpperCase() + value.slice(1)
    }
  },
  methods: {
    handleSelect: function (key, keyPath) {
      this.defaultActive = keyPath.toString()
      if (key !== null && key.indexOf('/') !== -1) {
        this.$router.push(key)
      } else {
        if (key === 1) {
          document.getElementsByClassName('userClass')[0].css('display', 'none')
        } else if (key === 2) {
          document.getElementsByClassName('currencyClass')[0].css('display', 'none')
        }
      }
    },
    handleOpen (key, keyPath) {
      console.log(key, keyPath)
    },
    handleClose (key, keyPath) {
      console.log(key, keyPath)
    },
    setCollapse () {
      this.isCollapse = !this.isCollapse
      localStorage.setItem('menuSet', this.isCollapse)
      if (this.isCollapse === false) {
        this.menuLogo = '/static/img/u7.svg'
      } else {
        this.menuLogo = '/static/img/u6.svg'
      }
      this.$emit('setCollapse', this.isCollapse)
    },
    currencySwitch: function (type) {
      // 切换币种
      this.defaultCurrency = type
      localStorage.setItem('currencySet', type)
      var urlpath = this.$route.path
      if (urlpath.indexOf('HotelList') !== -1 || urlpath.indexOf('HotelDetail') !== -1) {
        var query = JSON.parse(JSON.stringify(this.$route.query))
        query.currency = type
        this.$router.push({path: this.$route.path, query: query})
      }
      this.$emit('hotelDetailCurrency', type)
    },
    login: function () {
      let locationHref = window.document.location.href
      sessionStorage.setItem('LoginWebsiteAddress', locationHref)

      // 登录记录埋点
      this.clickPageAction('sign_in', '', {})
      this.$router.push({name: 'login'})
    },
    gotoHome: function () {
      // 点击埋点
      this.clickPageAction('logo')
      let Page = ''
      if (this.permissions.module) {
        if (this.permissions.module.includes(2)) {
          Page = 'MyTrip'
        } else if (this.permissions.module.includes(1)) {
          Page = 'HotelList'
        } else if (this.permissions.module.includes(4)) {
          Page = 'dashboard'
        } else if (this.permissions.module.includes(3)) {
          Page = 'myAccount'
        }
      } else {
        Page = 'MyTrip'
      }
      console.log('page:' + Page)
      this.$router.push({name: Page})
    },
    gotoSignIn: function () {
      let locationHref = window.document.location.href
      sessionStorage.setItem('LoginWebsiteAddress', locationHref)

      // 点击埋点
      this.clickPageAction('login')
      this.$router.push({name: 'login'})
    },
    JumpLogOut: function () {
      this.$router.push('/')
    },
    loginOut: function () {
      // 点击埋点
      this.clickPageAction('exit')

      // 判断用户是否登录 获取用户信息
      var token = localStorage.getItem('token')
      if (token !== undefined && token !== '') {
        var time = parseInt(new Date().getTime() / 1000)
        var dataJson = {'token': token, 'operation': 'loginOut', 'time': time}
        var data = this.common.encryptionData(dataJson, this)
        signIn(data).then(res => {
          if (res.flag === '200') {
            this.userLogin = false
            this.showLogin = true
            localStorage.removeItem('token')
            localStorage.removeItem('LoginWebsiteAddress')
            this.$router.push({name: 'login'})
          }
        })
      } else {
        this.userLogin = false
        this.showLogin = true
      }
    },
    // gotoPrevPage: function (e) {
    //   // e.srcElement.style.background = '#5F5D5D'
    //   if (this.$route.path.indexOf('HotelDetail') !== -1) {
    //     var regionSelJson = sessionStorage.getItem('mobile_hotellist_regionSel')
    //     var regionSelDetail = JSON.parse(regionSelJson)
    //     var regionSel = {'value_zh': regionSelDetail.value_zh, 'value_en': regionSelDetail.value_en, 'type_id': regionSelDetail.type_id, 'type_data_id': regionSelDetail.type_data_id}
    //     sessionStorage.setItem('regionSel', JSON.stringify(regionSel))
    //   }
    //   this.$router.go(-1)
    // },
    getHeadUserInfo: function () {
      // 判断用户是否登录 获取用户信息
      var token = localStorage.getItem('token')
      if (token !== undefined && token !== '') {
        var time = parseInt(new Date().getTime() / 1000)
        var dataJson = {'token': token, 'time': time, 'source': this.source}
        var data = this.common.encryptionData(dataJson, this)
        getUserInfo(data).then(res => {
          if (res.flag === '200') {
            this.userLogin = true
            this.showLogin = false
            this.LoginFirstName = res.data.showNickname
            this.email = res.data.email
            this.username = res.data.firstname + ' ' + res.data.lastname
            this.companyName = res.data.companyName
            this.sourceList = res.data.sourceInfo
            this.selectSource = res.data.platform
            this.$emit('getfirstName', this.LoginFirstName)
            this.allCurrency = res.data.currencyInfo.list
            this.limitInfo = res.data.credit
            this.permissions = res.data.permissions
            this.points = res.data.points
            this.$emit('getPermissions', this.permissions)
            this.$emit('getPublicCurrency', res.data.currencyInfo.default)
            var currencyCom = localStorage.getItem('currencySet')
            if (currencyCom === null || currencyCom === '' || currencyCom === undefined || currencyCom === 'undefined' || currencyCom === 'null') {
              this.defaultCurrency = res.data.currencyInfo.default
              this.common.currencySet(this.defaultCurrency)
            } else {
              this.defaultCurrency = currencyCom
            }
          } else {
            localStorage.removeItem('token')
            localStorage.removeItem('sessionid')
            localStorage.setItem('LoginWebsiteAddress', window.document.location.href)
            this.$router.push({name: 'login'})
          }
        })
      } else if (this.$route.path.indexOf('forgetPass') === -1) {
        this.login()
      }
    },
    changeSource: function () {
      // 判断用户是否登录 获取用户信息
      var token = localStorage.getItem('token')
      if (token === undefined || token === '') {
        let locationHref = window.document.location.href
        localStorage.setItem('LoginWebsiteAddress', locationHref)
        this.$router.push({name: 'login'})
      }
      let pagePath = this.$route.path
      var requestTime = parseInt(new Date().getTime())
      var time = parseInt(requestTime / 1000)
      var dataJson = {'token': token, 'time': time, 'sourceval': this.selectSource, 'currentPage': pagePath, 'operation': 'changeSource'}
      var data = this.common.encryptionData(dataJson, this)
      changeSource(data).then(res => {
        var responseTime = parseInt(new Date().getTime())
        this.loadPageView(data, res, requestTime, responseTime)

        if (res.flag === '200') {
          localStorage.setItem('token', res.data.token)
          let source = res.data.source
          if (source !== '' && source !== undefined && source !== null) {
            this.source = source
            var sourceExpiresAt = Date.now() + 3600000 * 5
            localStorage.setItem('source', this.source)
            localStorage.setItem('sourceExpiresAt', sourceExpiresAt)
          } else {
            localStorage.removeItem('source')
            localStorage.removeItem('sourceExpiresAt')
          }
          if (res.data.redirectPage !== '' && pagePath !== res.data.redirectPage) {
            this.$router.push({name: res.data.redirectPage, query: {'source': this.source}})
          } else {
            var query = JSON.parse(JSON.stringify(this.$route.query))
            query.source = this.source
            this.$router.push({path: pagePath, query: query})
            window.location.reload()
          }
        } else {
          let locationHref = window.document.location.href
          localStorage.setItem('LoginWebsiteAddress', locationHref)
          this.$router.push({name: 'login'})
        }
      })
    },
    accountClick: function () {
      // 点击埋点 埋点记录
      this.clickPageAction('myAccount', '', {'type': 'myAccount'})
      this.$router.push({name: 'myAccount', query: {'source': this.source}})
    },
    userTag () {
      if (this.permissions.order === 1) {
        return 'Full Access'
      } else {
        return 'View Only'
      }
    },
    gotoHotelList () {
      this.$router.push({
        name: 'HotelList',
        query: { source: this.source }
      })
    },
    showPointsDialog () {
      this.framePointsDialog = true
      this.framePointsDetailsDialog = false
    },
    showPointsDetailsDialog () {
      this.framePointsDetailsDialog = true
      this.framePointsDialog = false
      // 获取子组件实例并调用其方法
      this.$nextTick(() => {
        this.$refs.pointsDetails.getPointsList()
      })
    }
  }
}
</script>

<style scoped>
  /deep/ .el-select .el-input__inner:focus, .el-select .el-input.is-focus .el-input__inner,.el-range-editor.is-active, .el-range-editor.is-active:hover, .el-select .el-input.is-focus .el-input__inner{border-color:rgba(83, 102, 163, 1) !important;box-shadow:0px 0px 8px rgba(83, 102, 163, 1);}
  /deep/ .el-select-dropdown__item.selected{color: rgba(83, 102, 163, 1) !important;}
  .button-search{margin-top: 0 0 0 15px !important; width: 100px !important; float: none !important;}
  .lineheight{line-height: 36px;}
  .header{padding:0px;}
  .menu-height-5{height:5px;}
  .menu-height-15{height:15px;}
  .border-bottom-solid{border-bottom:solid 1px #ccc;}
  .alert-menu{font-family: PingFangSCRegular, 'PingFang SC', sans-serif;}
  .right-menu-Tips{height:45px;line-height:45px;font-size: 13px;margin: 0px 25px;overflow:hidden;}
  .right-menu-title{height:55px;line-height:55px;font-size: 15px;margin: 0px 25px;}
  .right-menu-title button{width: 100%;height: 45px;border-radius: 3px;border: solid 1px rgba(79, 76, 76, 1);background:rgba(79, 76, 76, 1);color:white;box-shadow: 0 4px 5px 1px #ccc;font-size: 15px;overflow:hidden;}
  .right-menu{margin: 0px 25px;margin-bottom: 10px;height:35px;line-height:35px;font-size: 16px;}
  .right-menu .menu-language{background:url(/static/img/menu/language.png) no-repeat;background-size: 19px;background-repeat: no-repeat;background-position: left;padding-left:35px;}
  .right-menu .menu-currency{background:url(/static/img/menu/currency.png) no-repeat;background-size: 19px;background-repeat: no-repeat;background-position: left;padding-left:35px;}
  .right-menu .menu-faq{background:url(/static/img/menu/FAQ.png) no-repeat;background-size: 19px;background-repeat: no-repeat;background-position: left;padding-left:35px;}
  .right-menu .menu-privacyPolicy{background:url(/static/img/menu/privacyPolicy.png) no-repeat;background-size: 19px;background-repeat: no-repeat;background-position: left;padding-left:35px;}
  .right-menu .menu-termsOfUse{background:url(/static/img/menu/termsOfService.png) no-repeat;background-size: 19px;background-repeat: no-repeat;background-position: left;padding-left:35px;}
  .right-menu .menu-aboutUs{background:url(/static/img/menu/aboutUs.png) no-repeat;background-size: 19px;background-repeat: no-repeat;background-position: left;padding-left:35px;}
  .right-menu .menu-contactUs{background:url(/static/img/menu/contactUs.png) no-repeat;background-size: 19px;background-repeat: no-repeat;background-position: left;padding-left:35px;}
  .right-menu .menu-myBookings{background:url(/static/img/menu/myItinerary.png) no-repeat;background-size: 19px;background-repeat: no-repeat;background-position: left;padding-left:35px;}
  .right-menu .menu-myAccount{background:url(/static/img/menu/myAccount.png) no-repeat;background-size: 19px;background-repeat: no-repeat;background-position: left;padding-left:35px;}
  .right-menu .menu-myFavorite{background:url(/static/img/menu/myCollection.png) no-repeat;background-size: 19px;background-repeat: no-repeat;background-position: left;padding-left:35px;}
  .right-menu .menu-myCoupon{background: url(/static/img/account/myCoupon.png) no-repeat;background-size: 15px;background-repeat: no-repeat;background-position: left;padding-left:35px;}
  .right-menu .menu-signOut{background:url(/static/img/menu/signOut.png) no-repeat;background-size: 19px;background-repeat: no-repeat;background-position: left;padding-left:35px;}
  .right-menu .left-ment-setup{text-align:right;font-size:13px;}
  .right-menu .right-ment-setup{font-size:13px;}
  .right-menu .alert-left{overflow: hidden;white-space: nowrap;font-size: 15px;}
  .right-menu .alert-right{text-align:right; color:#4F4C4C;font-size: 15px;}
  .right-menu .alert-right img{width: 32px;height: 20px;margin: -3px 0px;}
  .right-menu-hr{border-bottom:dashed 1px rgba(79, 76, 76, 1);height: 20px;}
  .account-menu{font-size: 16px;height:50px; line-height:50px;width: 100%;}
  /* .el-menu-item span{color:rgba(0, 0, 0, 0.24705882352941178);} */
  .el-menu--horizontal .el-menu-item:not(.is-disable):hover{color:rgba(83, 102, 163, 1);background-color:rgba(242, 242, 242, 1);}
  /deep/ .el-menu--popup{ min-width: 100px !important;}
  .header-login{width: auto;margin-right: 15px; float: right;}
  .userItem{padding-bottom:5px;}
  .right-header /deep/ .el-submenu__title{ width: auto;padding: 0 !important;font-size: 14px !important; margin-left: 20px;}

  .alert-menu .header-link{color: black;text-decoration: none;}
  .alert-menu .right-menu-group{margin:0px 25px;}
  /deep/ .el-menu .is-disabled .el-submenu__title{color: black !important; opacity:1;}
  /deep/ .el-menu--horizontal>.el-submenu.is-active .el-submenu__title{border: none;}
  /deep/ .el-menu--horizontal .el-menu .el-menu-item.is-active,  /deep/ .el-menu--horizontal .el-menu .el-submenu.is-active>.el-submenu__title{color: rgba(83, 102, 163, 1);}
  /deep/ .el-menu--popup{min-width: 120px;}
  .account-menu div{display: inline-block;}
  .balance-info{float: right;min-width: 200px;font-size:14px;width: auto;height: 60px;line-height: 60px;color: rgb(83, 102, 163); text-align: right;}
  /deep/ .el-icon-check{color: #333;}
  .el-menu--horizontal .el-menu-item:not(.is-disable):hover .el-icon-check {color:rgb(83, 102, 163); /* 将子元素的背景色设置为红色 */}
  .el-menu-vertical-demo:not(.el-menu--collapse) {
    width: 200px;
    min-height: 400px;
  }
  /deep/ .el-select-dropdown__item{padding: 0 15px;}
  /deep/ .el-range-editor.is-active, /deep/ .el-range-editor.is-active:hover, /deep/ .el-select .el-input.is-focus .el-input__inner{border-color: rgba(83, 102, 163, 1) !important;}
  /deep/ .el-submenu__title * {vertical-align: unset;}
  .username {
    font-size: 14px !important;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    /* display: inline-block; */
    max-width: 75%;
    margin-left:3px;
  }
  /deep/ .el-menu--horizontal>.el-submenu .el-submenu__title{border-bottom: none;}
  .user-tag {
    background-color: #f0f0f0;
    color: #1890FF;
    border: 0.5px solid #1890FF;
    border-radius: 2px;
    display: inline-block; /* 使span表现得像块级元素 */
    text-align: center; /* 文本居中 */
    white-space: nowrap; /* 防止文本换行 */
    padding: 0px 2px;
    line-height: 12px; /* 设置行高以适应高度 */
    font-size: 10px; /* 调整字体大小以适应高度 */
    margin-left:5px;
    margin-top: 23px;
    float: left;
  }
  .header-pointInfo {
    width: auto;
    min-width: fit-content;
    font-size: 14px;
    display: flex;
    align-items: center;
    height: 60px;
    float: left;
    margin-right: 10px;
  }

  .header-pointInfo div {
    display: flex;
    align-items: center;
    gap: 5px;
  }

  .point-detail {
    padding: 0px;
    width: 970px;
  }

  .point-title {
    margin-bottom: 15px;
  }

  .point-loyalty {
    font-size: 18px;
    font-weight: 800;
  }

  .point-loyalty-li {
    font-size: 12px;
    font-weight: 400;
    color: #4E5969;
  }

  .quarter-row-title {
    background: #F2F3F5;
    display: grid;
    grid-template-columns: repeat(6, 1fr);
    font-size: 16px;
    line-height: 46px;
    height: 46px;
    font-weight: 400;
  }

  .quarter-row {
    display: grid;
    grid-template-columns: repeat(6, 1fr);
    font-size: 16px;
    line-height: 46px;
    height: 46px;
    font-weight: 400;
    border-bottom: 1px solid #E5E6EB
  }

  .quarter-col {
    text-align: center;
    color: #333;
  }

  .points-progress {
    font-size: 14px;
    line-height: 46px;
    height: 46px;
    margin-bottom: -15px;
  }
</style>



// WEBPACK FOOTER //
// src/components/public/publicHeader.vue